import React from 'react';
import { Spin, SpinProps } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Icon = <LoadingOutlined style={{ fontSize: 50 }} spin />;

interface LoadingProps extends SpinProps {
  cover?: string;
  align?: string;
  icon?: React.ReactElement;
}

/**
 * Note: the delay effect only works if you specify the `spinning` property https://ant.design/components/spin/.
 */
const Loading = (props: LoadingProps) => {
  const { align = 'center', cover = 'inline', icon = Icon, ...rest } = props;
  return (
    <div className={`loading text-${align} cover-${cover}`}>
      <Spin delay={200} {...rest} indicator={icon} />
    </div>
  );
};

export default Loading;
